module.exports = __webpack_public_path__ + "templates.carousel-display-7b37be95.html";